import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IonSlides, NavController } from '@ionic/angular';
import { BasePage } from '../base.page';
import { LoginViewModel } from '../login/LoginViewModel';
import { OnboardingViewModel } from './OnBoardingViewModel';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.page.html',
  styleUrls: ['./onboarding.page.scss'],
})
export class OnboardingPage extends BasePage implements OnInit {

  @ViewChild(IonSlides) slides: IonSlides;

  private isEnd: boolean;
  private carroseis: any;
  private onboardingViewModel: OnboardingViewModel

  constructor(
    public router: Router,
    private navCtrl: NavController,
  ) {
    super(router)
  }

  private iniciaVariaveis() {
    this.onboardingViewModel = new OnboardingViewModel()
    this.onboardingViewModel.setContext(this)
  }

  async ngOnInit() {
    this.iniciaVariaveis();
    await this.getCarroseis();
  }

  private async getCarroseis() {
    this.carroseis = await this.onboardingViewModel.obtemCarroseis()
    console.log(this.carroseis);
  }

  private skipOnBoarding() {
    this.navCtrl.navigateRoot('login');
  }

  private nextOnBoarding() {
    this.slides.slideNext();
  }

  private async isEndSlide() {
    this.isEnd = await this.slides.isEnd();
  }

  private openLogin() {
    this.openPage('login')
  }

  private openCadastro() {
    this.openPage('cadastro')
  }

}
